export class CommunicationService {
  private static communicationService: CommunicationService

  private constructor() {}

  static singleton(): CommunicationService {
    if (!CommunicationService.communicationService) {
      CommunicationService.communicationService = new CommunicationService()
    }
    return CommunicationService.communicationService
  }

  emitCustomEvent(eventName: string, data: any) {
    const emit = new CustomEvent(eventName, { detail: data })
    window.dispatchEvent(emit)
  }

  receiveCustomEvent(eventName: string, listener: EventListener) {
    window.addEventListener(eventName, listener)
  }

  removeEventListener(eventName: string, listener: EventListener) {
    window.removeEventListener(eventName, listener)
  }
}
